import { ArrowDownRight, Headphones } from "lucide-react";

const HERO_IMG =
    "https://customer-assets.emergentagent.com/job_audio-engineer-denis/artifacts/232caglb_%20%20chaaaaaat.jpg";

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-32 lg:pt-40 pb-16 lg:pb-24 px-6 lg:px-12 overflow-hidden"
        >
            <div className="max-w-[1440px] mx-auto">
                <div className="grid grid-cols-12 gap-y-12 lg:gap-x-8">
                    {/* Big typography */}
                    <div className="col-span-12">
                        <h1
                            data-testid="hero-title"
                            className="font-serif-display text-center text-[18vw] sm:text-[14vw] lg:text-[11.5rem] xl:text-[14rem] leading-[0.85] tracking-[-0.04em] text-ink reveal-up"
                        >
                            I&nbsp;Finish
                            <br />
                            Records
                        </h1>
                    </div>
                </div>

                {/* Image + content row */}
                <div className="mt-16 lg:mt-20 grid grid-cols-12 gap-y-10 lg:gap-x-8 items-stretch">
                    {/* Image */}
                    <div className="col-span-12 lg:col-span-7 order-2 lg:order-1">
                        <div className="relative w-full overflow-hidden border border-black/15 bg-ink grain">
                            <img
                                src={HERO_IMG}
                                alt="Denis Catapano at the mixing desk"
                                className="w-full h-auto object-contain grayscale block"
                                data-testid="hero-image"
                            />
                        </div>
                    </div>

                    {/* Right column */}
                    <div className="col-span-12 lg:col-span-5 order-1 lg:order-2 lg:pl-10 flex flex-col justify-between">
                        <div>
                            <p
                                data-testid="hero-subtitle"
                                className="font-mono text-sm sm:text-base lg:text-[15px] leading-[1.7] tracking-[0.18em] uppercase text-ink"
                            >
                                Mixing &amp; mastering
                                <br />
                                <span className="text-quiet">for independent artists</span>
                                <br />
                                ready to release.
                            </p>

                            {/* CTAs */}
                            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                                <a
                                    href="#services"
                                    data-testid="hero-cta-primary"
                                    className="group inline-flex items-center justify-between gap-4 bg-ink text-bone px-6 py-4 font-mono text-[11px] tracking-[0.24em] uppercase hover:bg-bone hover:text-ink hover:ring-1 hover:ring-ink transition-all"
                                >
                                    View finishing options
                                    <ArrowDownRight
                                        size={16}
                                        className="transition-transform duration-300 group-hover:translate-x-1 group-hover:translate-y-1"
                                    />
                                </a>
                                <a
                                    href="#portfolio"
                                    data-testid="hero-cta-secondary"
                                    className="inline-flex items-center justify-between gap-4 border border-ink px-6 py-4 font-mono text-[11px] tracking-[0.24em] uppercase hover:bg-ink hover:text-bone transition-all"
                                >
                                    <span className="inline-flex items-center gap-2">
                                        <Headphones size={14} /> Listen to the work
                                    </span>
                                    <span aria-hidden>→</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const Stat = ({ n, label, testid }) => (
    <div data-testid={testid}>
        <p className="font-serif-display text-3xl text-ink leading-none">
            {n}
        </p>
        <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-quiet mt-2">
            {label}
        </p>
    </div>
);

export default Hero;
